module.exports = __webpack_public_path__ + "img/bg-type04.0c211ec8.png";